import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { ImportResultPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ImportResultModal } from 'modules/compensations/components/importResultModal'

const ResultsPage = ({ closePath }: { closePath: ((id: string) => string) | string }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const payrollRunId = parseInt(searchParams.get('payroll-run-id') || '0')

  const { data, error } = useQuery(ImportResultPageDocument, {
    fetchPolicy: 'network-only',
  })

  const canUseUniversalImporters = data?.universalImporter?._policies.importResources.can
  const authorized = canUseUniversalImporters && !error

  if (!authorized) {
    navigate(-1)
  }

  const onClose = () => {
    navigate(typeof closePath === 'function' ? closePath(id || '') : closePath)
  }

  return <ImportResultModal onClose={onClose} payrollRunId={payrollRunId} />
}

export default ResultsPage
